import { useQuery } from "@tanstack/react-query";
import { userApi } from "@bw/shared/api";
import type { MyBookingInvitationResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's incoming PENDING court invitations (GET /users/me/booking-invitations).
 *
 * Returned VERBATIM as MyBookingInvitationResponse objects — the backend scopes
 * the list to the token user and joins booking time + facility/court context +
 * the inviter's display name, so the cache key carries no uid and the page renders
 * the fields as given (never derives them). A respond mutation invalidates
 * `booking.myInvitations()` so the inbox re-reads the server's truth.
 *
 * `enabled` (default true) lets a caller gate the fetch on auth state — this is a
 * token-scoped `/me/*` read, so the home (which renders for anonymous visitors)
 * passes `Boolean(user)` and the read does NOT fire when logged out (no 401 spam);
 * the guarded inbox route leaves the default `true`.
 */
export function useMyBookingInvitations(enabled = true) {
  return useQuery<MyBookingInvitationResponse[]>({
    queryKey: queryKeys.booking.myInvitations(),
    queryFn: () => userApi.listMyBookingInvitations(),
    enabled,
  });
}
